import { Box } from "@mui/material";
import styled from "styled-components";

export const IconSelectorContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const IconPreview = styled(Box)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
`;

export const SearchBox = styled(Box)`
  padding: 12px;
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
  sticky: top;
  top: 0;
  z-index: 10;

  input {
    font-size: 13px;
  }

  .MuiOutlinedInput-root {
    background: white;

    &:hover {
      border-color: #1976d2;
    }

    &.Mui-focused {
      border-color: #1976d2;
    }
  }
`;

export const IconGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 8px;
  padding: 12px;
  max-height: 400px;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;

    &:hover {
      background: #555;
    }
  }
`;

interface IconItemProps {
  isSelected?: boolean;
}

export const IconItem = styled(Box)<IconItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  border: 2px solid ${props => (props.isSelected ? "#1976d2" : "#e0e0e0")};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: ${props => (props.isSelected ? "rgba(25, 118, 210, 0.1)" : "white")};
  user-select: none;

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }

  &:hover {
    border-color: #1976d2;
    background: rgba(25, 118, 210, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const IconLabel = styled.span`
  font-size: 11px;
  color: #666;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  width: 60px;
`;
